import { Navigate } from "react-router-dom";
import { useToken } from "./tokenContext";
import LoadingSkeleton from "../components/loading";
import PropTypes from "prop-types";

const ProtectedRoute = ({ children, slugPermission }) => {
  const { token, hasPermission, loading } = useToken();

  if (loading) {
    return <LoadingSkeleton />;
  }

  if (!token) {
    return <Navigate to="/login" />;
  }

  if (slugPermission) {
    if (!hasPermission(slugPermission)) {
      return <Navigate to="/semPermissao" />;
    }
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node,
  slugPermission: PropTypes.string.isRequired,
};

export default ProtectedRoute;
